// @view/panels/payment/choose-subscription/SelectedPackage.panel.tsx
import React from "react";
import EmptyView from "@view/EmptyView";
import type { VisibilityPhase } from "@ps-bridge/models/ui/visibilityPhase";
import SelectedPackageView from "@view/payment/choose-subscription/SelectedPackage.view";

export type SelectedPackagePanelProps = {
  phase: VisibilityPhase;
  selectedPackage: string;
  isPayAsYouGo: boolean;
};

const SelectedPackagePanel: React.FC<SelectedPackagePanelProps> = ({
  phase,
  selectedPackage,
  isPayAsYouGo,
}) => {
  const phaseKeys = {
    hidden: "hidden",
    visible: "visible",
  } as const satisfies Record<VisibilityPhase, VisibilityPhase>;

  const render = {
    [phaseKeys.hidden]: <EmptyView />,
    [phaseKeys.visible]: (
      <SelectedPackageView
        selectedPackage={selectedPackage}
        isPayAsYouGo={isPayAsYouGo}
      />
    ),
  } as const satisfies Record<VisibilityPhase, React.ReactElement>;

  return render[phase as keyof typeof render];
};

export default React.memo(SelectedPackagePanel, (prevProps, nextProps) => {
  return (
    prevProps.phase === nextProps.phase &&
    prevProps.selectedPackage === nextProps.selectedPackage &&
    prevProps.isPayAsYouGo === nextProps.isPayAsYouGo
  );
});
